import { SnapGuide } from '@src/components/timeline/SnapGuide';
import React from 'react';

import { EndMarker } from './controls/EndMarker';
import { Playhead } from './Playhead';
import { Tickmarks } from './Tickmarks';

interface TimelineHeaderProps {
  scale: number;
  duration: number;
  currentTime: number;
  maxWidth: number;
  extraTimeWidth: number;
  refScrollLeft: number;
  trackHeight: number;
  scrubToTime: (time: number) => void | Promise<void>;
  expandScaleForDuration: (newDuration: number) => void;
}

export const TimelineHeader: React.FC<TimelineHeaderProps> = ({
  maxWidth,
  extraTimeWidth,
  refScrollLeft,
  trackHeight,
  scrubToTime,
  expandScaleForDuration,
}) => {
  return (
    <>
      <Tickmarks
        maxWidth={maxWidth + extraTimeWidth}
        refScrollLeft={refScrollLeft}
      />
      <div
        onMouseDown={e => {
          e.stopPropagation();
        }}
      >
        <EndMarker expandScaleForDuration={expandScaleForDuration} />
        <Playhead trackHeight={trackHeight} scrubToTime={scrubToTime} />
        <SnapGuide />
      </div>
    </>
  );
};
